import * as preact from 'preact'
const { h, Component } = preact
import * as style from './style.css'
import { Heading, Paragraph } from '@nrk/dh-feature-components'
import PureComponent from '../../../lib/preact-pure-component'
import classNames from 'classnames'
import { Category } from './category'
export interface Role {
  text: string
  names: [{ name: string }]
}

interface Props {
  publishedAt: string
  updatedAt?: string
  roles: Role[]
  active: boolean
  preload: boolean
}

interface State {
  intersectionElements: any[]
  active?: number
}

export class Byline extends PureComponent<Props, State> {
  render() {
    const { roles, publishedAt, updatedAt, preload } = this.props
    const mappedRoles = roles.map(role => <Category role={role} key={role.text} />)
    const date = new Date(publishedAt)

    if (preload) {
      return (
        <div className={style.wrapper}>
          {mappedRoles}
          <div
            className={style.publishedAt}
          >{`Publisert: ${date.getDate()}.${date.getMonth()}.${date.getFullYear()}`}</div>
          {!!updatedAt && <div className={style.updatedAt}>{`Oppdatert: ${updatedAt}`}</div>}
        </div>
      )
    }
    return null
  }
}
